export const storagePrefix = 'mikado:';
